import { PropsWithChildren } from "react";
import { Stack } from "@fluentui/react/lib/Stack";

import { ITileBodyProps } from "./ITileBodyProps";
import { useTileBodyStyles } from "./UseTileBodyStyles";

export function TileBody(props: PropsWithChildren<ITileBodyProps>): JSX.Element {
  const { children, styleSet } = props;
  const styles = useTileBodyStyles(styleSet);
  return (
    <Stack.Item grow className={styles.root}>
      {children}
    </Stack.Item>
  );
}
